import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Search() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [searching, setSearching] = useState(false);
  const [mode, setMode] = useState('semantic');
  const navigate = useNavigate();

  const doSearch = useCallback(async () => {
    if (!query.trim()) return;
    setSearching(true);
    try {
      const r = await fetch(`/api/search?q=${encodeURIComponent(query)}&mode=${mode}&limit=20`);
      setResults(await r.json());
    } catch { setResults(null); }
    setSearching(false);
  }, [query, mode]);

  const simColor = (s) => s > 0.7 ? '#9ece6a' : s > 0.5 ? '#e0af68' : 'var(--text-muted)';

  return (
    <div style={{ padding: 'var(--gap-lg)', maxWidth: 900 }}>
      <h2 style={{ color: 'var(--text-primary)', marginBottom: 'var(--gap-lg)', fontSize: 'var(--font-size-xl)', fontWeight: 600 }}>Suche</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 'var(--gap-md)' }}>
        {['semantic', 'fulltext'].map(m => (
          <button key={m} onClick={() => setMode(m)} style={{ background: mode === m ? 'rgba(187,154,247,0.2)' : 'var(--bg-tertiary)', border: `1px solid ${mode === m ? '#bb9af7' : 'var(--border)'}`, borderRadius: 'var(--border-radius)', padding: '6px 14px', color: mode === m ? '#bb9af7' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 'var(--font-size-sm)' }}>
            {m === 'semantic' ? 'Semantisch' : 'Volltext'}
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input value={query} onChange={e => setQuery(e.target.value)} onKeyDown={e => e.key === 'Enter' && doSearch()} placeholder="Suchbegriff..." style={{ flex: 1, background: 'var(--bg-tertiary)', border: '1px solid var(--border)', borderRadius: 'var(--border-radius)', padding: '10px 14px', color: 'var(--text-primary)', fontSize: 'var(--font-size-base)', outline: 'none' }} />
        <button onClick={doSearch} disabled={searching} style={{ background: '#bb9af7', border: 'none', borderRadius: 'var(--border-radius)', padding: '10px 20px', color: '#1a1b26', fontWeight: 600, cursor: 'pointer', opacity: searching ? 0.6 : 1 }}>
          {searching ? '...' : 'Suchen'}
        </button>
      </div>
      {results && (
        <div style={{ marginTop: 'var(--gap-lg)' }}>
          <div style={{ color: 'var(--text-muted)', fontSize: 'var(--font-size-sm)', marginBottom: 12 }}>{results.total || 0} Ergebnisse</div>
          {(results.results || []).map((r, i) => (
            <div key={i} onClick={() => navigate(`/library/${r.document_id}`)} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 'var(--border-radius)', padding: 16, marginBottom: 8, cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <span style={{ color: 'var(--text-primary)', fontWeight: 500, fontSize: 'var(--font-size-base)' }}>{r.document_title || r.filename}</span>
                {r.page_number && <span style={{ background: 'var(--bg-tertiary)', borderRadius: 4, padding: '2px 6px', fontSize: 11, color: 'var(--text-muted)' }}>S. {r.page_number}</span>}
                {r.similarity != null && <span style={{ color: simColor(r.similarity), fontSize: 11, fontWeight: 600 }}>{Math.round(r.similarity * 100)}%</span>}
              </div>
              {r.section_title && <div style={{ color: '#bb9af7', fontSize: 'var(--font-size-sm)', marginBottom: 4 }}>{r.section_title}</div>}
              <div style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)', lineHeight: 1.5, maxHeight: 60, overflow: 'hidden' }}>{(r.content || '').slice(0, 300)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
